import React from "react";
import { Button, Card, Col, Divider, Image, Row, Space } from "antd";
import { BsArrowRight } from "react-icons/bs";
import "./serviceCardView.scss";
import { useNavigate } from "react-router-dom";
import NewTitle from "../../Components/NewTitle/NewTitle";
import arow_service from "../../assets/images/home/services/arow_service.webp";
import { CommonButton } from "../CommonButton";

const HomeServiceCard = ({ list }: any) => {
  const navigate = useNavigate();
  return (
    <div className="mainDivView">
      <NewTitle text="OUR SERVICES" textTitleClassName="textTitleClassName" />
      <div style={{ marginTop: "5vw" }}>
        <Row gutter={[32, 32]} justify={"center"}>
          {list.map((singleData: any, index: number) => {
            return (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={12}
                xl={8}
                xxl={8}
                key={"card" + index}
              >
                <Card
                  // title={singleData?.title}
                  className={`cardView`}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  bodyStyle={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    padding: 0,
                  }}
                >
                  <div style={{ flexGrow: 1 }} className={`cardView${index}`}>
                    {/* <img src={list.image} style={{border : "1px solid red", width : "100%"}}/> */}
                    <Image
                      src={singleData.image}
                      alt="GridView"
                      preview={false}
                    />
                    &nbsp;
                    <h5>
                      <strong>{singleData?.title}</strong>
                    </h5>
                    <h6>{singleData?.description}</h6>
                    <ul className="arrowUpdate">
                      {singleData?.subServices.map((e: any) => {
                        return (
                          <li>
                            <i>
                              <img src={arow_service} style={{ scale: ".6" }} />{" "}
                              {e}
                            </i>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div
                    style={{ textAlign: "center" }}
                    className="buttonSection"
                  >
                    <CommonButton
                      buttonText="Learn More"
                      link=""
                      onClick={() => {
                        navigate(singleData?.link);
                      }}
                      style={{ width: "25vh" }}
                      icon={<BsArrowRight />}
                      target=""
                    />
                    {/* <Button
                      onClick={() => {
                        navigate(singleData?.link);
                      }}
                    >
                      <Space>
                        Learn More
                        <BsArrowRight />
                      </Space>
                    </Button> */}
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default HomeServiceCard;
